"use client";
import { DownIcon } from "@/assets/icons";
import React, { useEffect, useRef, useState } from "react";
import Loading from "../Loading";

export default function Dropdown({
  items=[],
  title = "Title",
  state,
  setState,
  loading,
  ...props
}) {
  const [show, setShow] = useState(false);
  const optionsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        show
      ) {
        setShow(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => window.removeEventListener("click", handleClickOutside);
  }, [show]);

  const showHandler = (e) => {
    setShow((show) => !show);
  };

  const handleSelect = (select) => {
    setState(select);
    setShow(false);
  };

  return (
    <div className=" w-full">
      <span className=" text-sm lg:text-base inline-block font-normal leading-6 tracking-[0.5px] dark:text-dark-neutral-default text-neutral-default mb-3">
        {title}
      </span>
      <div
        {...props}
        ref={optionsRef}
        className={` select-none relative cursor-pointer w-full rounded dark:text-dark-neutral-default text-neutral-default lg:text-base text-sm dark:border-dark-medium border-medium ${
          show ? " border-2 p-[0px] " : "border p-[1px] "
        }`}
      >
        <div
          onClick={showHandler}
          className="flex p-[14px] lg:p-4 pe-3 justify-between"
        >
          {state || <span className=" opacity-50">Loading...</span>}
          <DownIcon
            className={`transition-transform ${show ? " rotate-180" : ""}`}
          />
        </div>
        {show ? (
          <div className=" z-20 rounded dark:bg-dark-surface2 bg-surface2 absolute animate-fade-in left-0 mt-2 py-2  w-full pe-1">
            {loading ? (
              <div className=" flex justify-center py-7">
                <Loading />
              </div>
            ) : (
              <div className=" max-h-[384px] overflow-y-auto scroll pe-1 ">
                {items.map((item) => (
                  <div
                    onClick={() => {
                      handleSelect(item);
                    }}
                    className=" select-none hover:dark:bg-dark-surface3 transition-all hover:bg-surface3 py-[11px] px-[16px] lg:px-6 leading-6"
                    key={item}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
